module.exports = __webpack_public_path__ + "static/media/paletteGenerator3.a3f16979.jpg";